const normalizeIdentifier = (value) =>
  String(value || '').trim().toLowerCase();

export const isClassroomMeeting = (meetingType) =>
  ['class', 'classroom'].includes(normalizeIdentifier(meetingType));

/**
 * The server remains the source of truth for canEndMeeting. This local policy
 * only removes authority: faculty may end a classroom when Core grants it,
 * but every other meeting type is leave-only for faculty.
 */
export const canParticipantEndMeeting = ({ access = {}, meetingType, role } = {}) => {
  if (access?.canEndMeeting !== true) return false;
  if (normalizeIdentifier(role) === 'faculty' && !isClassroomMeeting(meetingType)) {
    return false;
  }
  return true;
};

/**
 * Moving the minimized board is a local layout action. An admitted student
 * who can view the board may reposition it even while faculty presenter focus
 * controls the shared page and zoom; this never grants edit/manage authority.
 */
export const canStudentRepositionSharedBoard = (
  permissions = {},
  effectiveRole = permissions?.role
) =>
  normalizeIdentifier(effectiveRole) === 'student' &&
  permissions?.isAdmitted === true &&
  permissions?.canView === true;
